import { render } from "./DocumentDashboard.vue?vue&type=template&id=c94c01cc&scoped=true"
import script from "./DocumentDashboard.vue?vue&type=script&lang=js"
export * from "./DocumentDashboard.vue?vue&type=script&lang=js"

import "../assets/scss/document_dashboard.scss?vue&type=style&index=0&id=c94c01cc&scoped=true&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94c01cc"]])

export default __exports__